import { PayButtonLevel, } from '../models';
import { getTransactionRefs } from './transactionService';
export function isPaymentSuccessful(ogoneStatus) {
    const OGONE_SUCCESS_STATUSES = ['5', '4', '9', '41', '51', '91'];
    return ogoneStatus !== undefined && OGONE_SUCCESS_STATUSES.includes(ogoneStatus);
}
export function getPaymentDataRequestBody(value) {
    var _a;
    const { openTransactions, payButtonLevel, openTransactionToPayIndex, selectedAccount, communication, isUserSE, language, acceptUrl, declineUrl, isScarlet, } = value;
    const openTransactionToPay = openTransactionToPayIndex !== undefined
        ? openTransactions[openTransactionToPayIndex]
        : undefined;
    return {
        language,
        balance: getBalance(payButtonLevel, selectedAccount, openTransactionToPay),
        acceptUrl,
        declineUrl,
        homeUrl: 'NONE',
        templatePrefix: getTemplatePrefix(isUserSE, isScarlet !== null && isScarlet !== void 0 ? isScarlet : false),
        transactionRefs: getTransactionRefs(openTransactions, payButtonLevel, openTransactionToPay),
        comPlus: '',
        orderId: payButtonLevel === PayButtonLevel.transaction
            ? (_a = openTransactionToPay === null || openTransactionToPay === void 0 ? void 0 : openTransactionToPay.orderId) !== null && _a !== void 0 ? _a : ''
            : communication,
        paymentLevel: payButtonLevel === PayButtonLevel.transaction ? 'transaction' : 'balance',
    };
}
function getBalance(paymentLevel, billingAccount, openTransactionToPay) {
    var _a;
    switch (paymentLevel) {
        case PayButtonLevel.transaction:
            return (_a = openTransactionToPay === null || openTransactionToPay === void 0 ? void 0 : openTransactionToPay.amount) !== null && _a !== void 0 ? _a : '';
        case PayButtonLevel.balance:
            return billingAccount.balance;
        case PayButtonLevel.balancePOP:
            return billingAccount.overdueBalance;
    }
}
function getTemplatePrefix(isUserSE, isScarlet) {
    let templatePrefix;
    if (isScarlet) {
        templatePrefix = 'index-scarlet';
    }
    else {
        templatePrefix = isUserSE ? 'Proximustpfile01_bus' : 'Proximustpfile01_res';
    }
    return templatePrefix;
}
export function convertToUpdateBillingPaymentRequestBody(ogoneParams) {
    var _a, _b, _c;
    return {
        acceptance: ogoneParams.ACCEPTANCE,
        alias: (_a = ogoneParams.ALIAS) !== null && _a !== void 0 ? _a : ogoneParams.alias,
        amount: ogoneParams.amount,
        brand: ogoneParams.BRAND,
        cardNo: ogoneParams.CARDNO,
        cn: ogoneParams.CN,
        comPlus: ogoneParams.COMPLUS,
        currency: ogoneParams.currency,
        ed: ogoneParams.ED,
        ip: ogoneParams.IP,
        ncError: ogoneParams.NCERROR,
        orderId: ogoneParams.orderID,
        payId: ogoneParams.PAYID,
        payidsub: ogoneParams.PAYIDSUB,
        pm: ogoneParams.PM,
        sco_category: (_b = ogoneParams.SCO_CATEGORY) !== null && _b !== void 0 ? _b : ogoneParams.sco_category,
        scoring: (_c = ogoneParams.SCORING) !== null && _c !== void 0 ? _c : ogoneParams.scoring,
        shaSign: ogoneParams.SHASIGN,
        status: ogoneParams.STATUS,
        trxDate: ogoneParams.TRXDATE,
    };
}
export function getOgoneTemplate(paymentDataResponse, ogoneUrl) {
    const OPTIONAL_DEVICE_INPUT_TAG = paymentDataResponse.DEVICE
        ? `<input type="hidden" name="DEVICE" value="${paymentDataResponse.DEVICE}" />`
        : '';
    return `
    <form id="postForm" action="${ogoneUrl}" method="POST" style="display: none;">
      <input type="hidden" name="PSPID" value="${paymentDataResponse.PSPID}" />
      <input type="hidden" name="ORDERID" value="${paymentDataResponse.ORDERID}" />
      <input type="hidden" name="AMOUNT" value="${paymentDataResponse.AMOUNT}" />
      <input type="hidden" name="CURRENCY" value="${paymentDataResponse.CURRENCY}" />
      <input type="hidden" name="LANGUAGE" value="${paymentDataResponse.LANGUAGE}" />
      <input type="hidden" name="CN" value="${paymentDataResponse.CN}" />
      <input type="hidden" name="OWNERZIP" value="${paymentDataResponse.OWNERZIP}" />
      <input type="hidden" name="OWNERADDRESS" value="${paymentDataResponse.OWNERADDRESS}" />
      <input type="hidden" name="OWNERCTY" value="${paymentDataResponse.OWNERCTY}" />
      <input type="hidden" name="OWNERTOWN" value="${paymentDataResponse.OWNERTOWN}" />
      <input type="hidden" name="COMPLUS" value="${paymentDataResponse.COMPLUS}" />
      <input type="hidden" name="PMLIST" value="${paymentDataResponse.PMLIST}" />
      <input type="hidden" name="PMLISTTYPE" value="${paymentDataResponse.PMLISTTYPE}" />
      <input type="hidden" name="SHASIGN" value="${paymentDataResponse.SHASIGN}" />
      <input type="hidden" name="ACCEPTURL" value="${paymentDataResponse.ACCEPTURL}" />
      <input type="hidden" name="DECLINEURL" value="${paymentDataResponse.DECLINEURL}" />
      <input type="hidden" name="HOMEURL" value="${paymentDataResponse.HOMEURL}" />
      ${OPTIONAL_DEVICE_INPUT_TAG}
    </form>
    <script>document.getElementById("postForm").submit();</script>
  `;
}
// https://epayments-support.ingenico.com/en/integration-solutions/integrations/hosted-payment-page#eCommerce-get-transaction-feedback
// Note: Below are mandatory ogone feedback parameters.
export function includesOgoneMandatoryFeedbackParameters(params) {
    return ((params === null || params === void 0 ? void 0 : params.NCERROR) !== undefined ||
        (params === null || params === void 0 ? void 0 : params.PAYID) !== undefined ||
        (params === null || params === void 0 ? void 0 : params.orderID) !== undefined ||
        (params === null || params === void 0 ? void 0 : params.STATUS) !== undefined);
}
